import httpClient from './httpClient'

export default {

    /**
     * CSVをDBに登録する処理
     * @param {*} csv
     */
    async importCsv(csv) {
        let formData = new FormData()
        formData.append("file", csv)
        return httpClient.post('/devereach/admin/csv/upload', formData).then((response) => response)
    }
}